import { IAdhocNotification } from '../business-objects/common';
import * as actionTypes from './actionTypes';
import { NotificationsInfo } from '../../MultiSelect/common';

export interface INotificationState {
  adhocNotification: IAdhocNotification;
  notificationOptions: NotificationsInfo[];
}

const initialState: INotificationState = {
  adhocNotification: null,
  notificationOptions: [],
};

export default (state: INotificationState = initialState, action: any) => {
  let _state = { ...state };
  switch (action.type) {
    case actionTypes.CACHE_NOTIFICATION:
      _state.adhocNotification = action.value;
      return _state;
    case actionTypes.GET_ALL_ACTIVE_NOTIFICATION_TEMPLATES_INTO_STORE:
      _state = {
        ...state,
        notificationOptions: action.value,
      };
      return _state;
    default:
      return state;
  }
};
